<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Usuários</h3>
        </div>
        <!-- Page Header - Datepicker -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Usuários</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6 class="m-0">
                  {{ pagination.TotalItems | number }}
                  {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                </h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">
                      {{ labelName }}
                    </th>
                    <th scope="col" class="border-0 text-left">Cargo</th>
                    <th scope="col" class="border-0 text-left">Perfil</th>
                    <th scope="col" class="border-0">Data do cadastro</th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(userInternal, index) in users" :key="index">
                    <td></td>
                    <td class="text-left td-with-subs">
                      <div>{{ userInternal.Name | substring(50) }}</div>
                      <span>{{ userInternal.Identity | identity }}</span>
                    </td>
                    <td class="text-left">
                      <div>{{ userInternal.Occupation }}</div>
                      <span
                        class="td-span-style"
                        v-if="
                          userInternal.UserInternalRoot.Name != null &&
                          userInternal.UserInternalRoot.Name != undefined &&
                          userInternal.UserInternalRoot.Name != ''
                        "
                        >GESTOR(A):
                        {{ userInternal.UserInternalRoot.Name }}</span
                      >
                    </td>
                    <td class="text-left">
                      {{ userInternal.UserProfileInternal.Name }}
                    </td>
                    <td>{{ userInternal.CreatedDate | date }}</td>
                    <td></td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            v-if="$isAuthorize('UserInternal', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click.stop="
                              GetUserInternal(userInternal.Id, true)
                            "
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            v-if="$isAuthorize('UserInternal', 'Update')"
                            class="dropdown-item"
                            href="#"
                            v-on:click.stop="GetUserInternal(userInternal.Id)"
                          >
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                          <a
                            v-if="$isAuthorize('UserInternal', 'Delete')"
                            class="dropdown-item"
                            href="#"
                            v-on:click.stop="RemoveUserInternal(index)"
                          >
                            <i class="fas fa-trash-alt mr-2"></i> Remover
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      users == undefined || users == null || users.length == 0
                    "
                  >
                    <td colspan="6">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <b-pagination
                  class="pagination-nav float-right"
                  v-model="pagination.PageNumber"
                  :total-rows="pagination.TotalItems"
                  :per-page="pagination.RowsPerPage"
                  aria-controls="my-table"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="mFormUserInternal"
      :title="modalTitle"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <!-- Loader -->
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>
      <div v-else>
        <ValidationObserver ref="formValidation">
          <d-form-row>
            <!-- Name -->
            <d-col md="6" class="form-group">
              <label>{{ labelName }}</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-form-input
                  :class="validatedFormValidation | showValidateError(invalid)"
                  type="text"
                  v-model="infoUserInternal.Name"
                  placeholder="Nome"
                  :disabled="isSeeing"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedFormValidation"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <!-- Document -->
            <d-col md="6" class="form-group">
              <label>CPF</label>
              <ValidationProvider
                rules="required|min:11|identity"
                v-slot="{ errors, invalid }"
              >
                <the-mask
                  :class="validatedFormValidation | showValidateError(invalid)"
                  class="form-control"
                  type="tel"
                  :mask="['###.###.###-##']"
                  v-model="infoUserInternal.Identity"
                  placeholder="CPF"
                  :disabled="isSeeing || !isCreating"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedFormValidation"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
          <d-form-row>
            <!-- Email -->
            <d-col md="6" class="form-group">
              <label for="feEmail">E-mail</label>
              <ValidationProvider
                rules="required|email"
                v-slot="{ errors, invalid }"
              >
                <d-form-input
                  :class="validatedFormValidation | showValidateError(invalid)"
                  type="email"
                  v-model="infoUserInternal.Email"
                  placeholder="E-mail"
                  :disabled="!isCreating"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedFormValidation"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <!-- Phone -->
            <d-col md="6" class="form-group">
              <label for="parPhone">Telefone</label>
              <ValidationProvider
                rules="required|min:10"
                v-slot="{ errors, invalid }"
              >
                <d-input-group seamless>
                  <d-input-group-text slot="prepend">
                    <i class="fas fa-phone-alt"></i>
                  </d-input-group-text>
                  <the-mask
                    id="parPhone"
                    class="form-control"
                    :class="
                      validatedFormValidation | showValidateError(invalid)
                    "
                    type="tel"
                    :mask="['(##) #####-####', '(##) ####-####']"
                    v-model="infoUserInternal.Phone"
                    placeholder="Telefone"
                    :disabled="isSeeing"
                  />
                </d-input-group>
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedFormValidation"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
          <d-form-row>
            <!-- Occupation -->
            <d-col md="6" class="form-group">
              <label>{{ labelOccupation }}</label>
              <d-form-input
                type="text"
                v-model="infoUserInternal.Occupation"
                :placeholder="labelOccupation"
                :disabled="isSeeing"
              />
            </d-col>
            <!-- UserInternalRoot -->
            <d-col md="6" class="form-group">
              <label>Gestor(a)</label>
              <d-select
                v-model="infoUserInternal.UserInternalRoot.Id"
                :disabled="isSeeing"
                :value="0"
              >
                <option :value="0" selected>Selecione</option>
                <option
                  v-if="idUserInternal != userRoot.Id"
                  v-for="userRoot in usersRoot"
                  v-bind:value="userRoot.Id"
                  v-bind:key="userRoot.Id"
                >
                  {{ userRoot.Name }}
                </option>
              </d-select>
            </d-col>
          </d-form-row>
          <d-form-row>
            <!-- UserProfileInternal -->
            <d-col md="12">
              <div class="form-group">
                <label>Perfil</label>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors, invalid }"
                >
                  <d-select
                    v-model="infoUserInternal.UserProfileInternal.Code"
                    :class="
                      validatedFormValidation | showValidateError(invalid)
                    "
                    :disabled="
                      isSeeing ||
                      (!$isAdministrator() &&
                        $getUserInternal().Id !=
                          infoUserInternal.UserInternalRoot.Id)
                    "
                  >
                    <option :value="null" selected>Selecione</option>
                    <option
                      v-for="type in userProfiles"
                      v-bind:value="type.Code"
                      v-bind:key="type.Id"
                    >
                      {{ type.Name }}
                    </option>
                  </d-select>
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedFormValidation"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </div>
            </d-col>
          </d-form-row>
          <d-form-row v-if="isSeeing">
            <!-- CreatedDate -->
            <d-col md="12" class="form-group">
              <label>Data do cadastro</label>
              <d-form-input
                type="text"
                v-bind:value="
                  infoUserInternal.CreatedDate | date('DD/MM/YYYY - HH:mm')
                "
                :disabled="true"
              />
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="SaveUserInternal()"
          v-if="!isSeeing || isCreating"
          :disabled="loadingModal"
        >
          {{ isCreating == false ? "Salvar" : "Adicionar" }}
          <i class="fas fa-arrow-right"></i>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <input
            :placeholder="labelName"
            type="text"
            class="form-control"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="6" class="form-group">
          <the-mask
            class="form-control"
            type="tel"
            :mask="['###.###.###-##', '##.###.###/####-##']"
            v-model="filter.Identity"
            v-bind:placeholder="labelIdentity"
            v-on:keyup.enter.native="Filter()"
          />
        </d-col>
        <d-col md="12" class="form-group">
          <d-select v-model="filter.CodeUserProfileInternal">
            <option :value="null" selected>Perfil</option>
            <option
              v-for="type in userProfiles"
              v-bind:value="type.Id"
              v-bind:key="type.Id"
            >
              {{ type.Name }}
            </option>
          </d-select>
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      v-if="$isAuthorize('UserInternal', 'Delete')"
      href="#"
      class="btn-float success"
      v-b-tooltip.hover
      title="Novo usuário"
      v-on:click="OpenNewUserInternal()"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
export default {
  name: "users",
  data: function () {
    return {
      loadingList: false,
      loadingModal: false,
      isSeeing: false,
      isCreating: false,
      validatedFormValidation: false,
      countFilter: 0,
      labelName: "Nome",
      labelIdentity: "CPF",
      labelOccupation: "Cargo",
      modalTitle: "Novo usuário",
      users: [],
      usersRoot: [],
      userProfiles: [],
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      filter: {
        Name: null,
        Identity: null,
        CodeUserProfileInternal: null,
      },
      idUserInternal: 0,
      infoUserInternal: {
        Name: null,
        Identity: null,
        Email: null,
        Phone: null,
        Occupation: null,
        UserInternalRoot: {
          Id: 0,
        },
        UserProfileInternal: {
          Code: null,
        },
      },
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.ListUserInternal();
    },
  },
  mounted() {
    this.ListUserInternal();
    this.ListUserInternalRoot();
    this.ListUserProfileInternal();
  },
  methods: {
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListUserInternal();
    },
    ListUserInternal: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.Identity)) this.countFilter++;
      if (hasValue(this.filter.CodeUserProfileInternal)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.Name": this.filter.Name,
          "Object.Identity": this.filter.Identity,
          "Object.UserProfileInternal.Code": this.filter
            .CodeUserProfileInternal,
        },
      };
      this.$store
        .dispatch("ListUserInternal", { params: data })
        .then((response) => {
          this.users = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "warning",
            "Erro ao listar os usuários",
            error
          );
        })
        .finally(() => {
          this.loadingList = false;
        });
    },
    ResetFilter: function () {
      this.filter = {
        Name: null,
        Identity: null,
        CodeUserProfileInternal: null,
      };
      this.ListUserInternal();
    },
    ListUserInternalRoot: function () {
      let data = {
        ...{
          PageNumber: 0,
          RowsPerPage: 0,
        },
      };
      this.$store
        .dispatch("ListUserInternal", { params: data })
        .then((response) => {
          this.usersRoot = response.Objects;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "warning",
            "Erro ao listar os coordenadores",
            error
          );
        });
    },
    GetUserInternal: function (id, seeing) {
      this.loadingModal = true;
      this.isCreating = false;
      this.ResetInfoUserInternal();
      this.idUserInternal = id;
      this.$store
        .dispatch("GetUserInternal", { id: id })
        .then((response) => {
          this.infoUserInternal = response;

          if (typeof seeing != "undefined") {
            this.isSeeing = true;
            this.modalTitle = "Detalhes do usuário";
          } else {
            this.isSeeing = false;
            this.modalTitle = "Editar usuário";
          }

          this.ShowUserInternal();
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao carregar o usuário",
            error
          );
        })
        .finally(() => {
          this.loadingModal = false;
        });
    },
    RemoveUserInternal: function (i) {
      let deleted = this.users[i];
      this.$store
        .dispatch("DeleteUserInternal", { id: deleted.Id })
        .then(() => {
          this.$makeToast(
            `${deleted.Name} foi removido da sua lista de usuários.`,
            "success",
            "Usuário removido"
          );
          this.FeedbackUserInternal();
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao remover o usuário",
            error
          );
        });
    },
    ShowUserInternal: function () {
      this.validatedFormValidation = false;
      this.$bvModal.show("mFormUserInternal");
    },
    OpenNewUserInternal: function () {
      this.ResetInfoUserInternal();
      this.isCreating = true;
      this.isSeeing = false;
      this.modalTitle = "Novo usuário";
      this.ShowUserInternal();
    },
    ResetInfoUserInternal: function () {
      this.idUserInternal = 0;
      this.infoUserInternal = {
        Name: null,
        Identity: null,
        Email: null,
        Phone: null,
        Occupation: null,
        UserInternalRoot: {
          Id: 0,
        },
        UserProfileInternal: {
          Code: null,
        },
      };
    },
    SaveUserInternal: function () {
      this.validatedFormValidation = true;
      this.$refs.formValidation.validate().then((valid) => {
        if (valid) {
          this.AddOrUpdate();
        }
      });
    },
    AddOrUpdate() {
      this.loadingModal = true;
      if (this.isCreating) {
        // Add
        this.$store
          .dispatch("AddUserInternal", { userInternal: this.infoUserInternal })
          .then(() => {
            this.$makeToast(
              "O usuário foi cadastrado corretamente na base de dados.",
              "success",
              "Usuário cadastrado"
            );
            this.FeedbackUserInternal();
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao criar o usuário",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      } else {
        // Update
        this.$store
          .dispatch("UpdateUserInternal", {
            userInternal: this.infoUserInternal,
          })
          .then(() => {
            this.$makeToast(
              "Suas modificações foram salvas na base de dados.",
              "success",
              "Usuário atualizado"
            );
            this.FeedbackUserInternal();
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao atualizar o usuário",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    FeedbackUserInternal() {
      this.ListUserInternal();
      this.$bvModal.hide("mFormUserInternal");
    },
    ListUserProfileInternal: function () {
      let data = {
        ...{
          PageNumber: 0,
          RowsPerPage: 0,
        },
      };
      this.$store
        .dispatch("ListUserProfileInternal", { params: data })
        .then((response) => {
          this.userProfiles = response.Objects;
        })
        .catch((error) => {
          this.$makeToast(
            "Tente atualizar a página",
            "danger",
            "Erro ao obter lista de perfis",
            error
          );
        });
    },
  },
};
</script>

<style scoped>
.td-with-subs {
  display: block;
}
.td-with-subs > span {
  font-size: 10pt;
  opacity: 0.75;
}
.td-span-style {
  font-size: 9pt;
  opacity: 0.75;
}
.tr-hidden {
  border-top: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/users.vue